export const MY_GAME_FEATURE = "MY_GAME";
